import * as React from 'react';
import { Link } from 'react-router-dom';
import { isActivityNew } from 'src/utils/activityStatusUtils';
import { formatDate } from 'src/utils/dateUtils';
import Icon from '../Icon';
import Tag from '../Tag';

type CourseListRowProps = {
  id: number;
  title: string;
  startDate: string | null;
  startTime: string | null;
  endDate: string | null;
  endTime: string | null;
  themeId: number;
  categoryId: number;
  categoryName: string;
  publicationDate: string;
  location?: string;
  isFavorite?: boolean;
  isSignedUp?: boolean;
  onToggleFavorite?: (id: number) => void;
}

const getCourseDate = (
  startDate: string,
  startTime: string,
  endDate: string,
  endTime: string
) => `${formatDate(new Date(startDate), 'dd/MM/yyyy')} ${startTime} - ${formatDate(new Date(endDate), 'dd/MM/yyyy')} ${endTime}`;

export const CourseListRow = ({
  id,
  title,
  startDate,
  startTime,
  endDate,
  endTime,
  themeId,
  categoryId,
  categoryName,
  publicationDate,
  location,
  isFavorite,
  isSignedUp,
  onToggleFavorite,
}: CourseListRowProps) => {
  const handleToggleFavorite = (event: React.MouseEvent) => {
    event.preventDefault();

    if (onToggleFavorite) {
      onToggleFavorite(id);
    }
  };

  return (
    <Link
      className="flex justify-between has-background-gray-500 no-underline has-text-black"
      to={`/kursusside/${themeId}-${categoryId}-${id}`}
    >
      <div className="p-4">
        <div className="flex flex-wrap mb-1 f5">
          <Tag className="mr-1">{categoryName}</Tag>
          {isActivityNew(publicationDate) && <Tag className="mr-1" color="success">Nyt</Tag>}
          {startDate !== null && endDate !== null && startTime !== null && endTime !== null && (
            <div className="ml-2 mr-2 font-medium">
              {getCourseDate(startDate, startTime, endDate, endTime)}
            </div>
          )}
          {location && (
            <div className="flex items-center">
              <span className="mr-2">//</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                fill="none"
                viewBox="0 0 12 12"
                className="mr-1"
              >
                <path
                  fill="#000"
                  d="M2.82 8.18a4.5 4.5 0 116.36 0l-2.825 2.83a.498.498 0 01-.71 0L2.82 8.18zm5.655-.705a3.5 3.5 0 10-4.95 0L6 9.95l2.475-2.475zM6 7a2 2 0 110-4 2 2 0 010 4zm0-1a1 1 0 100-2 1 1 0 000 2z"
                />
              </svg>
              {location}
            </div>
          )}
          {isSignedUp === true && (
            <Tag className="ml-2" color="success">Tilmeldt</Tag>
          )}
        </div>
        <div className="flex items-center uppercase font-light leading-6">
          {title}
          <button
            className="flex items-center justify-center ml-2"
            onClick={handleToggleFavorite}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="15"
              viewBox="0 0 16 15"
              className="has-text-gray-600 cursor-pointer"
            >
              <path
                fill={isFavorite === true ? '#FAC917' : 'none'}
                fillRule="evenodd"
                stroke={isFavorite === true ? '#FAC917' : 'currentColor'}
                strokeLinejoin="round"
                d="M7.792.332l2.53 4.287 4.907.814-3.296 3.731.742 4.918L8.108 12.1l-4.447 2.226.473-4.956-3.49-3.542 4.858-1.082L7.792.332z"
              />
            </svg>
          </button>
        </div>
      </div>
      <div className="flex items-center justify-center p-6" style={{ backgroundColor: '#D9D9DA' }}>
        <div className="w-6 h-6 has-background-gray-400 rounded-full">
          <Icon name="chevron-right" className="w-4 h-4 m-1" />
        </div>
      </div>
    </Link>
  );
};



// WEBPACK FOOTER //
// ./src/components/CourseList/index.tsx